import { getRouterNavigator } from '@/routing'

export function handleTooManySessionsError() {
  const navigate = getRouterNavigator()
  navigate('error/too-many-sessions')
}
